import React from "react";
import styled, { css } from "styled-components";

import { RoundBadge } from "@examspark/common-ui/server";
import { TeksCategory, TeksCategoryMeta } from "@examspark/types";

const StyledRoundBadge = styled(RoundBadge)<{ category: TeksCategory }>`
  ${RoundBadge.Circle} {
    ${(props) => {
      switch (props.category) {
        case "READINESS":
          return css`
            color: #e62222;
            border: solid 1px #e62222;
          `;
        case "PROCESS":
          return css`
            color: #5e0389;
            border: solid 1px #5e0389;
          `;
        case "SUPPORTING":
          return css`
            color: #2c8458;
            border: dashed 1px #2c8458;
          `;
      }
    }}
  }
`;

const ObjectiveCategoryBadge = (props: {
  value: TeksCategory | null | undefined;
  showLabel?: boolean;
}) => {
  if (props.value == null) return null;
  const meta = TeksCategoryMeta[props.value];
  if (meta == null) return null;

  return (
    <StyledRoundBadge
      category={props.value}
      letter={meta.abbreviation}
      tooltip={`${meta.label} Standard`}
      label={props.showLabel && `${meta.label} Standard`}
    />
  );
};

export default styled(ObjectiveCategoryBadge)``;
